"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "autocomplete-select"
  }, [_c("b-field", {
    attrs: {
      label: _vm.label
    }
  }, [_c("AutocompleteInput", {
    attrs: {
      "on-fetch": _vm.onFetch,
      "keep-first": true,
      "open-on-focus": true,
      clearable: true,
      placeholder: _vm.placeholder
    },
    on: {
      select: _vm.handleSelect
    },
    model: {
      value: _vm.internalSelected,
      callback: function callback($$v) {
        _vm.internalSelected = $$v;
      },
      expression: "internalSelected"
    }
  })], 1), _vm._v(" "), _vm.showSelectedList ? _c("div", {
    staticClass: "selected-list"
  }, [_vm.selectedItems.length ? _c("ul", {
    staticClass: "selected-list__items"
  }, _vm._l(_vm.selectedItems, function (item) {
    return _c("li", {
      key: item[_vm.selectionProperty],
      staticClass: "selected-list__item"
    }, [_c("span", {
      staticClass: "selected-list__label"
    }, [_vm._v("\n          " + _vm._s(_vm.getItemLabel(item)) + "\n        ")]), _vm._v(" "), _c("b-button", {
      staticClass: "selected-list__remove",
      attrs: {
        type: "is-text",
        size: "is-small"
      },
      on: {
        click: function click($event) {
          return _vm.removeItem(item);
        }
      }
    }, [_c("b-icon", {
      attrs: {
        icon: "close-circle"
      }
    })], 1)], 1);
  }), 0) : _c("p", {
    staticClass: "selected-list__empty has-text-grey is-size-7"
  }, [_vm._v("\n      Nenhum item selecionado.\n    ")])]) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;